import React from 'react';
interface AnnaWordmarkProps {
  /** Font size in px */
  size: number;
  className?: string;
}

/**
 * The word "anna" as it appears in the boot sequence. Used wherever Anna is present but nothing
 * has been asked yet, so the opening and the waiting state are one and the same.
 */
export function AnnaWordmark({
  size,
  className = ''
}: AnnaWordmarkProps) {
  return <span className={`block font-display font-extralight lowercase leading-none tracking-[0.08em] text-ink ${className}`} style={{
    fontSize: size
  }} data-id="element-1319" data-mp="9e0rz2y0nirn">
      anna
    </span>;
}